export default "__VITE_ASSET__CpmPmhyX__"